import { extend } from 'flarum/common/extend';
import VerifiedBadge from '../common/components/VerifiedBadge';

/**
 * Add the verified badge as its own item in the post header item list.
 */
export default function addBadgeToCommentPost() {
  extend('flarum/forum/components/CommentPost', 'headerItems', function (items) {
    const post = this.attrs.post;
    const user = post && post.user && post.user();
    if (!user || !user.isVerified || !user.isVerified()) return;
    items.add('verified', m(VerifiedBadge, {
      user: user,
      className: "VerifiedBadge--post"
    }), 95);
  });
}